import {ListView} from '@github-ui/list-view'
import {ListViewMetadata} from '@github-ui/list-view/ListViewMetadata'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Link as RouterLink} from '@github-ui/react-router'
import {PullsListItem} from '@github-ui/shared-dashboard-lists/pulls/PullsListItem'
import {testIdProps} from '@github-ui/test-id-props'
import {ArrowLeftIcon, GitBranchIcon} from '@primer/octicons-react'
import {BranchName, CounterLabel} from '@primer/react'
import {useMemo} from 'react'

import {StackClosedBanner} from '../components/stacks/StackClosedBanner'
import {StackDetailHeader} from '../components/stacks/StackDetailHeader'
import styles from '../components/stacks/Stacks.module.css'
import {STACKS_CONTENT_TEST_ID} from '../components/stacks/test-ids'
import {repoPullsToListItems} from '../helpers/repo-pulls-dashboard-proto'
import {repoStackDetailRoute} from './repo-stack-detail-route'
import {stacksListPath} from './repo-stacks-list-route'

export function RepoStackDetail() {
  const {owner, repo} = useRouteParams(repoStackDetailRoute)
  const {data} = useSuspenseRouteQuery(repoStackDetailRoute, 'mainQuery')
  // The server orders pull requests from the top of the stack to its base. They can't be selected or reordered here.
  const pulls = useMemo(() => repoPullsToListItems(data.pullRequests), [data.pullRequests])
  const stack = data.stack
  if (!stack) return null

  return (
    <div {...testIdProps(STACKS_CONTENT_TEST_ID)}>
      <RouterLink to={stacksListPath({owner, repo})} className={styles.backLink}>
        <ArrowLeftIcon />
        Back to stacks
      </RouterLink>
      <StackDetailHeader />
      <StackClosedBanner />
      <div className={styles.listWrapper}>
        <ListView
          title={`Pull requests in stack #${stack.number}`}
          titleHeaderTag="h2"
          singularUnits="pull request"
          pluralUnits="pull requests"
          totalCount={pulls.length}
          as="ul"
          role="list"
          metadata={
            <ListViewMetadata title="Pull requests" trailingContent={<CounterLabel>{pulls.length}</CounterLabel>} />
          }
        >
          {pulls.map(pull => (
            <PullsListItem key={String(pull.id)} pull={pull} showUnreadIndicator={false} />
          ))}
        </ListView>
        <div className={styles.BaseFooter}>
          <GitBranchIcon size={16} aria-hidden="true" />
          <span>Base branch</span>
          <BranchName as="span" className={styles.BranchName}>
            {stack.baseRefName}
          </BranchName>
        </div>
      </div>
    </div>
  )
}
